import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component PinSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <PinSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <PinSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PinSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      data-testid="PinSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M1.292 2.87a1 1 0 0 0 0 1.412l2.684 2.683.385 1.792a.5.5 0 0 0 .353.379.5.5 0 0 0 .49-.128l1.549-1.55 2.395 2.396a.5.5 0 0 0 .706-.706L7.459 6.753l1.549-1.55a.498.498 0 0 0-.254-.842l-1.789-.385-2.683-2.684a1 1 0 0 0-1.413 0zm6.362 2.275-.899-.193a1 1 0 0 1-.496-.27L3.576 1.998 1.998 3.577l2.684 2.683c.136.136.23.308.27.496l.193.899z"
        clipRule="evenodd"
      />
    </svg>
  )
);
PinSmallIcon.displayName = "PinSmallIcon";
export default PinSmallIcon;
